import React, { Component } from 'react';
import { Modal, Radio, DatePicker, message } from 'antd';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
const radioStyle = {
    display: 'block',
    height: '30px',
    marginLeft: '20px',
    lineHeight: '30px',
};

class ExportModal extends Component {
    state = {
        visible: false,
        data: {},
    }

    show = () => {
        this.setState({
            data: {},
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleSubmit = () => {
        const { data } = this.state;
        const { exportType, beginDate, endDate } = data;
        if (exportType) {
            if (exportType == 'TEACHER_LIST_SCORE') {
                if (!beginDate || !endDate) {
                    message.warning('请选择统计月份');
                    return;
                } else if (beginDate && endDate) {
                    if (moment(beginDate).valueOf() > moment(endDate).valueOf()) {
                        message.warning('统计月份开始时间不能大于结束时间');
                        return;
                    }
                }
            }
            const { searchParams, pagination } = this.props;
            const { areaParams = {}, hasCheckedArea,  areaName, ...restParams } = searchParams;
            const exportParams = {
                ...data,
                ...restParams,
                ...areaParams,
            };
            ExportUtil.export({...exportParams}, pagination, API_URL.home.exportTeacherScore);
        }
        this.hide();
    }

    handleRadioChange = (e, exportType) => {
        const { data } = this.state;
        data.exportType = exportType;
        data.beginDate = undefined;
        data.endDate = undefined;
        this.setState({ data });
    }

    handleDateChange = (dateString, field) => {
        const { data } = this.state;
        data[field] = dateString;
        this.setState({ data });
    }

    disabledDate = (current) => {
        const month = current.month();
        return (
            current &&
            !(month === 5 || month === 11)
        );
    }

    render() {
        const { visible, data } = this.state;
        const { exportType, beginDate, endDate } = data;
        const newBeginDate = beginDate ? moment(beginDate) : null;
        const newEndDate = endDate ? moment(endDate) : null;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                width="450px"
            >
                <div>
                    <p>请选择导出内容：</p>
                    <Radio style={radioStyle} checked={exportType == 'TEACHER_LIST'} onChange={e => this.handleRadioChange(e, 'TEACHER_LIST')}>带教绩效排行列表</Radio>
                    <Radio style={radioStyle} checked={exportType == 'TEACHER_DETAIL_LIST'}  onChange={e => this.handleRadioChange(e, 'TEACHER_DETAIL_LIST')}>带教绩效排行列表（含考核明细项得分）</Radio>
                    <Radio style={radioStyle} checked={exportType == 'TEACHER_LIST_SCORE'}  onChange={e => this.handleRadioChange(e, 'TEACHER_LIST_SCORE')}>带教老师绩效分</Radio>
                    {
                        exportType == 'TEACHER_LIST_SCORE' &&
                        <div style={{marginLeft:43}}>
                            <span style={{marginRight: 15}}>统计月份</span>
                            <MonthPicker
                                value={newBeginDate}
                                format={monthFormat}
                                placeholder="请选择"
                                disabledDate={this.disabledDate}
                                style={{width: 120, verticalAlign: 'middle'}}
                                onChange={(date, dateString) => this.handleDateChange(dateString, 'beginDate')}
                            />
                            <span style={{ marginLeft: 10, marginRight: 10 }}>~</span>
                            <MonthPicker
                                value={newEndDate}
                                format={monthFormat}
                                placeholder="请选择"
                                disabledDate={this.disabledDate}
                                style={{width: 120, verticalAlign: 'middle'}}
                                onChange={(date, dateString) => this.handleDateChange(dateString, 'endDate')}
                            />
                        </div>
                    }
                </div>
            </Modal>
        );
    }
}

export default ExportModal;



// WEBPACK FOOTER //
// ./src/components/home/TeachingRank/components/ExportModal.js